module.exports = __webpack_public_path__ + "static/media/opensans-light.f49314cf.woff2";